import axios from "axios";

const baseURL = process.env.REACT_APP_API_SERVER_URL || "";

const apiClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

export const apiRequest = async (method, url, { data, params, headers } = {}) => {
  const response = await apiClient.request({ method, url, data, params, headers });
  return response;
};

export default apiClient;


